import { format, formatRelative, isToday, isTomorrow } from 'date-fns';

export const formatRelativeOrAbsoluteDateTime = (dateAndTime: Date) => {
  if (isToday(dateAndTime) || isTomorrow(dateAndTime)) {
    return formatRelative(dateAndTime, new Date());
  }
  return `on ${format(dateAndTime, "do MMM yyyy 'at' h:mm a")}`;
};
